// GovX Nigeria — shared content & assets

export const LOGO_DARK =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_f6dd4e38-c096-4ecf-a7aa-1c819f4c8152/artifacts/q45341pw_468_20260811_164406_0000.png";
export const LOGO_LIGHT =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_f6dd4e38-c096-4ecf-a7aa-1c819f4c8152/artifacts/2ks6yw78_469_20260811_164406_0001.png";

export const IMAGES = {
  lagosBridge: "https://images.unsplash.com/photo-1719314073622-9399d167725b",
  lagosBridge2: "https://images.unsplash.com/photo-1719314313652-d9835e0c52c3",
  kanoInterchange: "https://images.pexels.com/photos/31729398/pexels-photo-31729398.jpeg",
  roadBillboard: "https://images.unsplash.com/photo-1745725427532-4c52cdc6d4ae",
  lagosCityscape: "https://images.unsplash.com/photo-1745725427994-30530297f537",
  kadunaAerial: "https://images.pexels.com/photos/20817774/pexels-photo-20817774.jpeg",
  riverBridge: "https://images.unsplash.com/photo-1765475467677-579353b25ce0",
  community: "https://images.unsplash.com/photo-1668246153111-07549350eda7",
  durbar: "https://images.unsplash.com/photo-1729974897977-0696b5e90aa8",
  womanSmiling: "https://images.unsplash.com/photo-1509099863731-ef4bff19e808",
  classroom: "https://images.unsplash.com/photo-1632215861513-130b66fe97f4",
  citySunset: "https://images.unsplash.com/photo-1569706971306-de5d78f6418e",
  citySkyline: "https://images.unsplash.com/photo-1559833064-6f4573ec1ac9",
  cityRiver: "https://images.unsplash.com/photo-1704230093731-8dad84d386a9",
  techTeam: "https://images.unsplash.com/photo-1573164574511-73c773193279",
  coding: "https://images.unsplash.com/photo-1531482615713-2afd69097998",
  manLaptop: "https://images.unsplash.com/photo-1528901166007-3784c7dd3653",
  groupCouch: "https://images.unsplash.com/photo-1655720357872-ce227e4164ba",
  healthMask: "https://images.unsplash.com/photo-1609188076864-c35269136b09",
  nurseDoorway: "https://images.pexels.com/photos/5327869/pexels-photo-5327869.jpeg",
  nursePortrait: "https://images.pexels.com/photos/6097985/pexels-photo-6097985.jpeg",
  boardroom: "https://images.unsplash.com/photo-1739298061707-cefee19941b7",
  conference: "https://images.unsplash.com/photo-1573167507387-6b4b98cb7c13",
  lagosBW: "https://images.pexels.com/photos/29715199/pexels-photo-29715199.jpeg",
  manSuit: "https://images.pexels.com/photos/35659738/pexels-photo-35659738.jpeg",
  radioTech: "https://images.pexels.com/photos/15174673/pexels-photo-15174673.jpeg",
  lagosColor: "https://images.pexels.com/photos/37405043/pexels-photo-37405043.jpeg",
  abujaGate: "https://images.unsplash.com/photo-1554457606-ed16c39db884",
  abujaTower: "https://images.unsplash.com/photo-1661332628354-3ec604f4411d",
  abujaHill: "https://images.unsplash.com/photo-1639774274707-09c80b4f53e3",
  lagosVI: "https://images.unsplash.com/photo-1618828665011-0abd973f7bb8",
  lagosVIblue: "https://images.unsplash.com/photo-1618828665347-d870c38c95c7",
  lagosCity2: "https://images.unsplash.com/photo-1749058387715-1efad0eadc8c",
  proWomen: "https://images.unsplash.com/photo-1573164574397-dd250bc8a598",
  proMacbook: "https://images.unsplash.com/photo-1573167101669-476636b96cea",
  construction: "https://images.unsplash.com/photo-1637019916030-9f851c2eca13",
  nationalAssembly: "https://images.unsplash.com/photo-1733122051092-c19022119205",
  nassComplex: "https://images.unsplash.com/photo-1735385102811-199278409ee2",
  civicFlag: "https://images.unsplash.com/photo-1604212563354-546134b8004f",
};

export const NAV = [
  { label: "What We Do", to: "/what-we-do" },
  { label: "Government", to: "/government" },
  { label: "Political", to: "/political" },
  { label: "Digital", to: "/digital" },
  { label: "Impact", to: "/impact" },
  { label: "Insights", to: "/insights" },
  { label: "Partner", to: "/partner" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const WHO_WE_WORK_WITH = [
  {
    group: "Government",
    items: ["Federal ministries & agencies", "State governments", "Local governments", "Governors' & executive offices", "Delivery units & PMOs"],
  },
  {
    group: "Political",
    items: ["Political parties", "Candidates & public leaders", "Campaign organisations", "Political foundations"],
  },
  {
    group: "Public Impact",
    items: ["Development partners & donors", "Public institutions", "Corporates & investors", "Technology partners", "Media & research"],
  },
];

export const HERO_FLOW = [
  "Policy",
  "Strategy",
  "Programmes",
  "Implementation",
  "Measurement",
  "Impact",
];

export const CAPABILITIES = [
  {
    id: "government",
    index: "01",
    title: "Government",
    to: "/government",
    tagline: "Build better systems. Deliver better outcomes.",
    body: "Governance transformation, programme management, institutional strengthening, citizen experience and delivery support.",
    cta: "Explore Government",
    image: IMAGES.kanoInterchange,
  },
  {
    id: "political",
    index: "02",
    title: "Political",
    to: "/political",
    tagline: "Build organisations that can execute.",
    body: "Political strategy, organisational systems, campaign operations, communications, research and field coordination.",
    cta: "Explore Political",
    image: IMAGES.nationalAssembly,
  },
  {
    id: "digital",
    index: "03",
    title: "Digital",
    to: "/digital",
    tagline: "Technology built around public-sector problems.",
    body: "Digital platforms, dashboards, citizen engagement, AI-enabled outreach, CRM and programme-management systems.",
    cta: "Explore Digital",
    image: IMAGES.coding,
  },
  {
    id: "impact",
    index: "04",
    title: "Impact & Intelligence",
    to: "/impact",
    tagline: "Measure what actually changes.",
    body: "Research, governance intelligence, monitoring, evaluation, public feedback and performance measurement.",
    cta: "Explore Impact",
    image: IMAGES.cityRiver,
  },
];

export const MODEL = [
  { n: "01", title: "Diagnose", body: "Understand the institution, problem, people and constraints." },
  { n: "02", title: "Design", body: "Build the strategy, operating model, programme and systems." },
  { n: "03", title: "Deliver", body: "Work alongside teams to coordinate implementation." },
  { n: "04", title: "Measure", body: "Track progress, identify bottlenecks and measure outcomes." },
  { n: "05", title: "Improve", body: "Use data and feedback to continuously improve delivery." },
];

export const PUBLIC_IMPACT = [
  { k: "Policy", q: "What was decided?" },
  { k: "Programme", q: "What was designed?" },
  { k: "Delivery", q: "What was implemented?" },
  { k: "Measurement", q: "What happened?" },
  { k: "Citizen", q: "What changed?" },
];

export const FRAMEWORK_DIMENSIONS = [
  "Planning",
  "Funding",
  "Capacity",
  "Execution",
  "Monitoring",
  "Citizen Experience",
  "Outcomes",
];

// Radar sample shape (illustrative geometry only — not real scores)
export const DELIVERY_INDEX = [
  { dimension: "Planning", value: 78 },
  { dimension: "Funding", value: 64 },
  { dimension: "Execution", value: 52 },
  { dimension: "Capacity", value: 60 },
  { dimension: "Monitoring", value: 45 },
  { dimension: "Citizen Exp.", value: 58 },
  { dimension: "Outcomes", value: 49 },
];

export const BETTER_GOV = [
  { n: "01", title: "Clearer Priorities", body: "Everyone knows what matters." },
  { n: "02", title: "Better Execution", body: "Teams know what needs to happen next." },
  { n: "03", title: "Visible Outcomes", body: "Leaders and citizens can see what changed." },
];

// ---------------- Government page ----------------
export const GOVERNMENT = {
  hero: {
    eyebrow: "Government Practice",
    title: "Government Has A Delivery Problem. We Help Solve It.",
    copy: "GovX Nigeria partners with government institutions to strengthen the systems between policy and outcomes.",
    cta: "Talk to GovX Government",
    image: IMAGES.abujaTower,
  },
  flow: ["Policy", "Programme", "Implementation", "Monitoring", "Citizen Outcome"],
  services: [
    {
      title: "Governance Transformation",
      body: "Government performance depends not only on policies but on the institutions responsible for implementing them.",
      items: ["Institutional diagnostics", "Governance assessments", "Organisational design", "Process re-engineering", "Institutional capacity building"],
      image: IMAGES.boardroom,
    },
    {
      title: "Programme & Project Management",
      body: "Translate priorities into workstreams, milestones and measurable objectives — then keep them moving.",
      items: ["PMO setup", "Programme design", "Project tracking", "Milestone management", "Risk management", "Interdepartmental coordination", "Delivery reviews"],
      image: IMAGES.roadBillboard,
    },
    {
      title: "Monitoring & Evaluation",
      body: "Monitoring tells leadership what is happening. Evaluation tells leadership whether it is working.",
      items: ["KPI frameworks", "Performance dashboards", "Programme monitoring", "Impact assessment", "Outcome measurement"],
      image: IMAGES.cityRiver,
    },
    {
      title: "Citizen Experience",
      body: "A government service is experienced as a journey — not a policy document. We design around the journey.",
      items: ["Citizen journey mapping", "Feedback systems", "Grievance workflows", "Citizen communications", "Service experience measurement", "AI-enabled citizen engagement"],
      image: IMAGES.classroom,
    },
    {
      title: "Government Communications",
      body: "A government can build something important and still fail to communicate its value.",
      items: ["Policy communication", "Programme communication", "Public information campaigns", "Digital communications", "Stakeholder engagement", "Crisis communications"],
      image: IMAGES.radioTech,
    },
  ],
};

// ---------------- Political page ----------------
export const POLITICAL = {
  hero: {
    eyebrow: "Political Practice",
    title: "Build The Organisation Behind The Leader.",
    copy: "Political success requires more than visibility. It requires strategy, organisation, people, systems, communication and disciplined execution. GovX Political helps parties, candidates and political organisations build the infrastructure required to organise, communicate and execute.",
    cta: "Talk to GovX Political",
    image: IMAGES.boardroom,
  },
  flow: ["Strategy", "Organisation", "People", "Field", "Communication", "Data", "Execution"],
  services: [
    { title: "Political Strategy", items: ["Strategic positioning", "Political research", "Issue mapping", "Stakeholder analysis", "Policy / platform development", "Strategic communications"], image: IMAGES.conference },
    { title: "Organisation", items: ["Party organisational systems", "Membership structures", "Volunteer coordination", "Internal communications", "State / LGA coordination", "Performance systems"], image: IMAGES.community },
    { title: "Campaign Operations", items: ["Campaign planning", "Programme management", "War-room operations", "Field coordination", "Event management", "Volunteer operations", "Reporting systems"], image: IMAGES.womanSmiling },
    { title: "Communications", items: ["Political brand strategy", "Digital strategy", "Content", "Creative", "Video", "Media relations", "Website & digital platforms"], image: IMAGES.techTeam },
    { title: "Research & Intelligence", items: ["Political landscape analysis", "Public opinion research", "Issue research", "Media intelligence", "Stakeholder mapping", "Campaign performance analysis"], image: IMAGES.manLaptop },
  ],
  transition: {
    flow: ["Campaign", "Transition", "Government", "Delivery Unit", "Performance"],
    cards: [
      { title: "GovX Campaign", body: "Strategy + Organisation + Operations" },
      { title: "GovX Transition", body: "Planning + Institutional handover + Priorities" },
      { title: "GovX Government", body: "Delivery + PMO + Performance" },
    ],
  },
};

// ---------------- Digital page ----------------
export const DIGITAL = {
  hero: {
    eyebrow: "Digital Practice",
    title: "Technology Should Make Government Work Better.",
    copy: "GovX Digital builds technology around real government, political and citizen problems — not technology for technology's sake.",
    cta: "Talk to GovX Digital",
    image: IMAGES.coding,
  },
  products: [
    { title: "GovX Delivery", sub: "Programme and project management for government.", steps: ["Plan", "Assign", "Monitor", "Escalate", "Report"] },
    { title: "GovX Citizen", sub: "Citizen engagement and feedback infrastructure.", steps: ["Listen", "Inform", "Respond", "Measure"] },
    { title: "GovX Political", sub: "Digital infrastructure for political organisations.", steps: ["Organise", "Communicate", "Mobilise", "Measure"] },
    { title: "GovX Intelligence", sub: "Governance and political intelligence.", steps: ["Track", "Analyse", "Understand", "Act"] },
  ],
  stack: ["AI", "Data", "Dashboards", "CRM", "Voice", "WhatsApp", "SMS", "Web", "Analytics"],
};

// ---------------- Impact page ----------------
export const IMPACT = {
  hero: {
    eyebrow: "Impact & Intelligence",
    title: "If You Can't Measure It, You Can't Improve It.",
    copy: "GovX combines research, data, monitoring and citizen feedback to understand whether programmes are actually delivering the outcomes they were designed to achieve.",
    cta: "Talk to GovX Intelligence",
    image: IMAGES.cityRiver,
  },
  services: [
    { title: "Governance Intelligence", body: "Track policies, institutions, programmes and public-sector developments." },
    { title: "Monitoring & Evaluation", body: "Measure implementation against objectives across the results chain." },
    { title: "Citizen Intelligence", body: "Understand citizen experience, feedback and service gaps." },
    { title: "Programme Analytics", body: "Turn fragmented project information into decision-ready dashboards." },
    { title: "Research", body: "Policy, institutional, political and public-interest research." },
  ],
};

// ---------------- About page ----------------
export const WHY_GOVX = [
  { n: "01", title: "We Stay Close To Implementation", body: "Not just recommendations. We work alongside the teams that execute." },
  { n: "02", title: "We Connect Disciplines", body: "Strategy, technology, communications, research and operations in one team." },
  { n: "03", title: "We Build Systems", body: "Our goal isn't dependency. It's institutional capability that stays." },
  { n: "04", title: "We Measure Outcomes", body: "Success is defined by what changed — not by activity." },
  { n: "05", title: "We Understand The Public Sector", body: "Built around public-sector constraints, stakeholders and accountability." },
];

export const INTEGRITY = [
  "Confidentiality",
  "Data Responsibility",
  "Conflict Management",
  "Regulatory Compliance",
  "Responsible AI",
  "Evidence-Based Advice",
];

// ---------------- Contact ----------------
export const CONTACT_AS = [
  "Government Institution",
  "Political Organisation",
  "Candidate / Public Leader",
  "Development Organisation",
  "Corporate / Investor",
  "Technology Partner",
  "Media / Research",
  "Other",
];

export const HELP_WITH = [
  "Strategy",
  "Programme Delivery",
  "Project Management",
  "Digital Transformation",
  "Communications",
  "Research",
  "Citizen Engagement",
  "Political Operations",
  "Monitoring & Evaluation",
  "Other",
];

export const INSIGHT_CATEGORIES = [
  "All", "Governance", "Policy", "Politics", "Economy", "Technology", "Public Sector", "Nigeria", "Africa",
];
